/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';

const InputText = function ({
  id, name, required, type = 'text', placeholder, target, hidden,
  defaultValue, minLength,
}) {
  return (
    <div
      className="inputText embeddedServiceSidebarFormField"
      style={{ display: hidden ? 'none' : 'block' }}
      data-target={target}
    >
      <div className="uiInput uiInputText uiInput--default uiInput--input">
        <label htmlFor={id} className="uiLabel-left form-element__label uiLabel">
          <span>{name}</span>
          {required ? <span title="Required" className="required">*</span> : undefined}
        </label>
        <input
          maxLength="255"
          minLength={minLength}
          id={id}
          name={name}
          placeholder={placeholder}
          type={type}
          className={`${id} slds-style-inputtext input`}
          required={required}
          disabled={hidden}
          value={defaultValue}
        />
      </div>
    </div>
  );
};

export default InputText;
